import { render, staticRenderFns } from "./AccountDefaultCard.vue?vue&type=template&id=8bcf21d2&scoped=true"
import script from "./AccountDefaultCard.vue?vue&type=script&lang=js"
export * from "./AccountDefaultCard.vue?vue&type=script&lang=js"
import style0 from "./AccountDefaultCard.vue?vue&type=style&index=0&id=8bcf21d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcf21d2",
  null
  
)

export default component.exports